import { useState, useEffect, useRef } from "react";

//componentes
import Header from "../../../../components/Header";
import Sidebar from "../../../../components/Sidebar";
import Legenda from "../../../../components/Legenda";
//Utils
import { dataAtual, dataAtualDia1, formatarData } from "../../../../utils/datas";
import { statusSolicitacao } from "../../../../utils/choices";

//Mui
import { Input, Select, Stack, Typography, Option, Button, Table, Switch, Link, Modal, ModalDialog, ModalClose, Tooltip, Autocomplete } from "@mui/joy";
import { FaArrowUp, FaArrowDown, FaCopy, FaExternalLinkAlt, FaSearch, FaFilter } from "react-icons/fa";

//Material
import { Pagination } from '@mui/material/';
import useMediaQuery from '@mui/material/useMediaQuery';

import { toast } from 'react-toastify';
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

//API
import { api } from "../../../../services/api";
import Paginacao from "../../../../components/Paginacao";
import { GoLinkExternal } from "react-icons/go";
import { enumProcesso, obterPrioridade } from "../../../../utils/criterios";

const dadosUsuarioLogado = { grupo: [] };
let idUsuario = 0;
let token = "";

//Dados do usuário logado no localstorage
const usuarioLogado = JSON.parse(localStorage.getItem('usuario'));

export default function CentralTarefas(props) {

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const nSolicitacaoRef = useRef(null);

    //Verificando se o dispositivo é mobile
    const mobile = useMediaQuery('(max-width:1200px)');

    const [dataInicio, setDataInicio] = useState(dataAtualDia1());
    const [dataTermino, setDataTermino] = useState(dataAtual());
    const [status, setStatus] = useState(1);
    const [tarefas, setTarefas] = useState([]);
    const [paginas, setPaginas] = useState({
        paginaAtual: 1,
        numeroPaginas: 1
    });
    const [verTodasTarefas, setVerTodasTarefas] = useState(false);
    const [aprovadorLogado, setAprovadorLogado] = useState(false);
    const [etapaAtualBuscada, setEtapaAtualBuscada] = useState(null);

    const [ordenaDataAbertura, setOrdenaDataAbertura] = useState(null);
    const [ordenaUltimaMovimentacao, setOrdenaUltimaMovimentacao] = useState(null);
    const [ordenaSolicitacao, setOrdenaSolicitacao] = useState(null);
    const [ordenaSolicitante, setOrdenaSolicitante] = useState(null);
    const [ordenaEtapaAtual, setOrdenaEtapaAtual] = useState(null);
    const [ordenaComprador, setOrdenaComprador] = useState(null);
    const [obraPesquisada, setObraPesquisada] = useState("");
    const [processoPesquisado, setProcessoPesquisado] = useState("");
    const [numMovPesquisado, setNumMovPesquisado] = useState("");
    const [modalExibirItens, setModalExibirItens] = useState(false);
    const [filtros, setFiltros] = useState({ solicitante: "", dataInicio: "", dataTermino: "", status: "", etapaAtualBuscada: "", numMovPesquisado: "", obraPesquisada: "", processoPesquisado: "", verTodasTarefas: searchParams.get('verTodasTarefas') === 'true', semCotacao: searchParams.get('semCotacao') === 'true', pagina: 1, item: "", prefixoEquipamento: "" });
    const [modalFiltros, setModalFiltros] = useState(false);
    const [itensDaRequisicao, setItensDaRequisicao] = useState([]);
    const [listagemUsuarios, setListagemUsuarios] = useState([]);
    const [primeiraBusca, setPrimeiraBusca] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (JSON.parse(localStorage.getItem("usuario")) != null) {
            dadosUsuarioLogado.nome = usuarioLogado.user.nome;
            dadosUsuarioLogado.usuario = usuarioLogado.user.login;
            dadosUsuarioLogado.obra = usuarioLogado.user.obra;
            dadosUsuarioLogado.grupo = usuarioLogado.grupo;
            dadosUsuarioLogado.id = usuarioLogado.user?.id;

            token = JSON.parse(localStorage.getItem('usuario')).token;
            idUsuario = JSON.parse(localStorage.getItem('usuario')).user.id;

            let permissoes = [];
            if (dadosUsuarioLogado.grupo.length > 0) {
                dadosUsuarioLogado.grupo.forEach((item) => {
                    permissoes.push(item.perfil);
                })
            }
            dadosUsuarioLogado.permissoes = permissoes;

            listaUsuarios(); //Carregar filtro de usuarios solicitantes.
        }
        // buscarTarefas();

    }, []);

    //Recarrega a lista toda vez que clica nas datas:
    useEffect(() => {
        if (filtros.dataInicio && filtros.dataTermino && filtros.status) {
            buscarTarefas(paginas.paginaAtual);
        }
    }, [ordenaDataAbertura, ordenaUltimaMovimentacao, ordenaSolicitacao, ordenaSolicitante, ordenaEtapaAtual, ordenaComprador]);

    useEffect(() => {
        const solicitanteBuscado = searchParams.get('solicitante') || undefined;
        const dataInicio = searchParams.get('dataInicio') || dataAtualDia1();
        const dataTermino = searchParams.get('dataTermino') || dataAtual();
        const status = searchParams.get('status') ? parseInt(searchParams.get('status')) : 1;
        const etapaAtualBuscada = searchParams.get('etapaAtualBuscada') || undefined;
        const numMovPesquisado = searchParams.get('numMovPesquisado') || undefined;
        const obraPesquisada = searchParams.get('obraPesquisada') || undefined;
        const processoPesquisado = searchParams.get('processoPesquisado') || undefined;
        const verTodasTarefas = searchParams.get('verTodasTarefas') || undefined;
        const semCotacao = searchParams.get('semCotacao') || undefined;
        const pagina = Number(searchParams.get('pagina')) || 1;
        const item = searchParams.get('item') || undefined;
        const prefixoEquipamento = searchParams.get('prefixoEquipamento') || undefined;

        paginas.paginaAtual = pagina;

        const filtros = { solicitanteBuscado, dataInicio, dataTermino, status, etapaAtualBuscada, numMovPesquisado, obraPesquisada, processoPesquisado, verTodasTarefas, semCotacao, pagina, item, prefixoEquipamento };
        setFiltros({ solicitanteBuscado, dataInicio, dataTermino, status, etapaAtualBuscada, numMovPesquisado, obraPesquisada, processoPesquisado, verTodasTarefas, semCotacao, pagina, item, prefixoEquipamento });

        if (filtros.dataInicio && filtros.dataTermino) {
            setTimeout(() => {
                buscarTarefas(pagina, filtros);
            }, 1000);
        }
    }, []);

    useEffect(() => {
        if (modalFiltros) {
            setTimeout(() => {
                if (modalFiltros && nSolicitacaoRef.current) {
                    nSolicitacaoRef.current.focus();
                }
            }, 100);
        }
    }, [modalFiltros]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                // setModalFiltros(false);
                buscarTarefas();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [filtros]);

    const handleOrdenaDataAbertura = () => {
        // define estado da variavel ordenaDataAbertura (estados null, true ou false)
        if (ordenaDataAbertura == null) {
            setOrdenaDataAbertura(true);
        } else if (ordenaDataAbertura == true) {
            setOrdenaDataAbertura(false);
        }
        else if (ordenaDataAbertura == false) {
            setOrdenaDataAbertura(null);
        }
        //ignorar a ordenacao de outras datas:
        setOrdenaUltimaMovimentacao(null);
    }

    const handleOrdenaUltimaMovimentacao = () => {
        // define estado da variavel ordenaUltimaMovimentacao (estados null, true ou false)
        if (ordenaUltimaMovimentacao == null) {
            setOrdenaUltimaMovimentacao(true);
        } else if (ordenaUltimaMovimentacao == true) {
            setOrdenaUltimaMovimentacao(false);
        }
        else if (ordenaUltimaMovimentacao == false) {
            setOrdenaUltimaMovimentacao(null);
        }
        //ignorar a ordenacao de outras datas:
        setOrdenaDataAbertura(null);
    }

    const handleOrdenaSolicitante = () => {
        if (ordenaSolicitante == null) {
            setOrdenaSolicitante(true);
        } else if (ordenaSolicitante == true) {
            setOrdenaSolicitante(false);
        }
        else if (ordenaSolicitante == false) {
            setOrdenaSolicitante(null);
        }
    }

    const handleOrdenaEtapaAtual = () => {
        if (ordenaEtapaAtual == null) {
            setOrdenaEtapaAtual(true);
        } else if (ordenaEtapaAtual == true) {
            setOrdenaEtapaAtual(false);
        }
        else if (ordenaEtapaAtual == false) {
            setOrdenaEtapaAtual(null);
        }
    }

    const handleOrdenaComprador = () => {
        if (ordenaComprador == null) {
            setOrdenaComprador(true);
        } else if (ordenaComprador == true) {
            setOrdenaComprador(false);
        }
        else if (ordenaComprador == false) {
            setOrdenaComprador(null);
        }
    }

    const handleOrdenaSolicitacao = () => {
        if (ordenaSolicitacao == null) {
            setOrdenaSolicitacao(true);
        } else if (ordenaSolicitacao == true) {
            setOrdenaSolicitacao(false);
        }
        else if (ordenaSolicitacao == false) {
            setOrdenaSolicitacao(null);
        }
    }

    const buscarTarefas = (pagina = 1, filters = filtros) => {
        setLoading(true);
        //Definindo obra e etapa atual com base no session storage
        // const obra = dadosUsuarioLogado.grupos == null ? null : dadosUsuarioLogado.obra;
        let obra = JSON.parse(localStorage.getItem("usuario")).user.obra;
        //pegar grupos que o usuario esteja:
        let _grupos = usuarioLogado.grupo;
        if (_grupos) {
            _grupos.forEach((element, indice) => {
                if (obra.includes(element.obra) == false) {
                    obra = obra + "," + element.obra;
                }
            });
        }
        const perfil = dadosUsuarioLogado.grupo.length == 0 ? "Solicitante" : "Aprovador";
        const etapaAtual = dadosUsuarioLogado.grupo ? dadosUsuarioLogado.permissoes.length > 0 ? dadosUsuarioLogado.permissoes.map(permission => permission.replace(" ", "%20")).join(",") : "" : null;
        //Verificando se o usuário logado não possui nenhuma permissão, se isso ocorrer, ele é definido como solicitante, senão, aprovador
        setAprovadorLogado(etapaAtual != "");
        //Definindo a pagina atual da variav el de estado de acordo com a página passada por parametro para a função
        // paginas.paginaAtual = pagina;
        //TODO: etapa atual: só pode ver a obra do usuário ou várias obras?

        if (!filters.dataInicio) {
            filters.dataInicio = dataAtualDia1();
        }

        if (!filters.dataTermino) {
            filters.dataTermino = dataAtual();
        }

        let urlBuscarTarefas = "";
        if (etapaAtualBuscada != null) {
            urlBuscarTarefas = `/solicitacoes?status=${filters.status}&datasolicitacaoi=${filters.dataInicio}&datasolicitacaof=${filters.dataTermino}&usuario=${idUsuario}&page=${pagina}&todos=${filters.verTodasTarefas}&perfil=${perfil}&etapaatual=${etapaAtualBuscada}`;
        } else {
            urlBuscarTarefas = `/solicitacoes?status=${filters.status}&datasolicitacaoi=${filters.dataInicio}&datasolicitacaof=${filters.dataTermino}&usuario=${idUsuario}&page=${pagina}&todos=${filters.verTodasTarefas}&perfil=${perfil}`;
        }

        //ordenar por comprador, etapaAtual e solicitante:
        if (ordenaSolicitacao != null) {
            urlBuscarTarefas += `&solicitacaoOrder=${ordenaSolicitacao}`;
        }
        if (ordenaSolicitante != null) {
            urlBuscarTarefas += `&orderSolicitante=${ordenaSolicitante}`;
        }
        if (ordenaEtapaAtual != null) {
            urlBuscarTarefas += `&orderEtapaAtual=${filters.etapaAtualBuscada}`;
        }
        if (ordenaComprador != null) {
            urlBuscarTarefas += `&orderComprador=${ordenaComprador}`;
        }

        //Ordenar data criacao:
        if (ordenaDataAbertura != null) {
            urlBuscarTarefas += `&orderDataAbertura=${ordenaDataAbertura}`;
        }
        //Ordenar ultima movimentacao
        else if (ordenaUltimaMovimentacao != null) {
            urlBuscarTarefas += `&orderUltimaMovimentacao=${ordenaUltimaMovimentacao}`;
        }
        //filtros de Termos pesquisados:
        if (filters.obraPesquisada) {
            urlBuscarTarefas += `&obraPesquisada=${filters.obraPesquisada}`
        }
        if (filters.numMovPesquisado) {
            urlBuscarTarefas += `&numMovPesquisado=${filters.numMovPesquisado}`
        }
        if (filters.processoPesquisado) {
            urlBuscarTarefas += `&solicitacao=${filters.processoPesquisado}`
        }
        if (filters.etapaAtualBuscada) {
            urlBuscarTarefas += `&etapaatual=${filters.etapaAtualBuscada}`
        }
        if (filters.item) {
            urlBuscarTarefas += `&item=${filters.item}`
        }
        if (filters.prefixoEquipamento) {
            urlBuscarTarefas += `&prefixoEquipamento=${filters.prefixoEquipamento}`
        }
        if (filters.solicitante) {
            urlBuscarTarefas += `&solicitante=${filters.solicitante.id}`
        }
        if (filters.semCotacao) {
            urlBuscarTarefas += `&semcotacao=${filters.semCotacao}`
        }

        api.get(urlBuscarTarefas,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        )
            .then((response) => {
                let tarefasDoBanco = [];
                if (response.data) {
                    const data = response.data;
                    data.data.forEach(tarefa => {
                        tarefasDoBanco.push(
                            {
                                solicitacao: tarefa.id,
                                solicitante: tarefa.nome,
                                etapaAtual: tarefa.etapaAtual,
                                // dataAbertura: formatarData(tarefa.dataSolicitacao.split(" ")[0]),
                                dataAbertura: formatarData(tarefa.created_at.split("T")[0]),
                                ultimaMovimentacao: formatarData(tarefa.updated_at.split("T")[0]),
                                status: tarefa.status,
                                obra: tarefa.localEstoque,
                                decisao: tarefa.decisao,
                                tipoPedido: tarefa.tipoPedido,
                                comprador: tarefa.comprador || "N/A",
                                compradorID: tarefa.compradorID,
                                aprovadorAtual: tarefa?.etapaPresente?.usuario || "",
                                numeroPms: tarefa.numeroPms,
                                filial: tarefa.filial,
                                localEstoque: tarefa.localEstoque,
                                criterio: obterPrioridade(tarefa.criterio),
                                jaReprovado: tarefa.fluxo_aprovacao.includes("Reprovado"),
                                multiplosAprovadores: tarefa.multiplosAprovadores
                            }
                        );
                    });
                    setTarefas(tarefasDoBanco);
                    //Definindo a paginação
                    paginas.numeroPaginas = data.meta.last_page;

                }

                if (primeiraBusca) {
                    setModalFiltros(false);
                }
                else {
                    setPrimeiraBusca(true);
                }

            }).catch((error) => {
                console.log(error);
                if (error?.response?.data) {
                    if (error.response.data.message == "Unauthenticated.") {
                        localStorage.setItem("usuario", null);
                        // navigate("/acessoNegado");
                        navigate("/");
                    }
                    else {
                        toast.error("Ocorreu um erro ao obter as solicitações");
                        console.log(error.response.data.message);
                    }
                }
                toast.error(JSON.stringify(error?.response?.data));
            }).finally(() => {
                setLoading(false);
            });
    }

    const alterarPagina = (_, value) => {
        paginas.paginaAtual = value;
        buscarTarefas(value);
        aplicarFiltros('pagina', value);
    }

    const checarSolicitacaoEmProcessamento = (solicitacao, novaAba = false, event = null) => {
        console.log("Checando solicitação em processamento...");
        if (event) {
            event.stopPropagation();
        }

        api.get(`/solicitacoes/${solicitacao}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        )
            .then(function ({ data }) {
                //solicitação em processamento, não pode ser acessada por 2 min:
                if (data.data.emProcessamento) {
                    console.log("em processamento. wait!");
                    toast.info("Esta solicitação está em processamento. Por favor, Aguarde até que ela fique disponível.");
                } else {
                    if (novaAba) {
                        window.open('/solicitacao/' + solicitacao)
                    }
                    else {
                        navigate("/solicitacao/" + solicitacao + location.search);
                    }
                }
            })
            .catch(function (err) {
                console.log(err);
                toast.error(JSON.stringify(err.response.data));
            });

    }

    const exibirItens = (e, solicitacao) => {
        e.stopPropagation();

        //Verificando se a requisição esta processada no RM
        api.get(`/solicitacoes/${solicitacao}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        )
            .then(function ({ data }) {
                //solicitação em processamento, não pode ser acessada por 2 min:
                if (data.data.emProcessamento) {
                    console.log("em processamento. wait!");
                    toast.info("Esta solicitação está em processamento. Por favor, Aguarde até que ela fique disponível.");
                } else {

                    //Obtendo tipos de pedido para saber o nome certo
                    api.get(`/tiposPedido/`,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`
                            }
                        }
                    )
                        .then((response) => {
                            console.log(response);
                            const tiposPedido = response.data;
                            //Obtendo os itens da requisição
                            setItensDaRequisicao(data.data.itens.map(itens => ({ ...itens, tipoPedido: tiposPedido.find(tp => tp.tipoPedido == data.data.tipoPedido).descricao })));
                            setModalExibirItens(true);
                        }).catch((err) => {

                            toast.error(JSON.stringify(err.response.data));
                        });
                }
            })
            .catch(function (err) {
                console.log(err);
                toast.error(JSON.stringify(err.response.data));
            });
    }

    const copiarNumMovimento = async (event, numeroMovimento) => {
        event.stopPropagation();
        try {
            await navigator.clipboard.writeText(numeroMovimento);
            toast.info("Movimento copiado");
        } catch (err) {
            console.error("Erro ao copiar:", err);
            toast.warning("Erro ao copiar o movimento");
            toast.error(JSON.stringify(err));
        }
    }

    const aplicarFiltros = (key, value) => {
        setFiltros(current => ({ ...current, [key]: value }));

        setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            if (value) next.set(key, value);
            else next.delete(key);
            return next;
        });
    };

    const resetFilters = () => {
        const filtros = { solicitante: "", dataInicio: dataAtualDia1(), dataTermino: dataAtual(), status: 1, etapaAtualBuscada: "", numMovPesquisado: "", obraPesquisada: "", processoPesquisado: "", verTodasTarefas: false, semCotacao: false, pagina: 1 };
        setFiltros(filtros);
        buscarTarefas(1, filtros);
    }


    const listaUsuarios = (page = 1) => {
        api.get("/usuariosRelac/?paginacao=false")
            .then((response) => {
                if (response.data.data) {
                    let usuarios = [];
                    const usuariosDoBanco = response.data.data;
                    usuariosDoBanco.forEach(usuario => {
                        usuarios.push(
                            {
                                id: usuario.id,
                                nome: usuario.nome
                            }
                        )
                    });
                    setListagemUsuarios(usuarios);
                }
            })
            .catch((err) => {
                console.error("ops! ocorreu um erro ao buscar usuarios: " + err);
                toast.error(JSON.stringify(err.response.data));
            });
    }


    return (
        <Stack flex={1} backgroundColor="#fff" height="100%" minHeight={"100vh"}>
            <Header notification mobile={mobile} />
            <Sidebar mobile={mobile} />

            <Stack ml={mobile ? "0px" : "280px"} mt={"50px"} flex={1} height={mobile ? "100%" : "calc(100% - 55px)"} p={mobile ? "20px" : "50px"} overflowY="auto">
                {/* Conteúdo da Tela */}
                <Stack flexDirection={'row'} justifyContent={'space-between'}>
                    <Typography level="h4">Central de Requisições</Typography>
                    <Legenda mobile={mobile} />
                </Stack>
                <Stack ml={mobile ? "0px" : "0px"}>
                    <Stack rowGap={"1rem"} flexWrap={"wrap"} flexDirection={mobile ? "column" : "row"} mt={mobile ? "20px" : "30px"} alignItems={mobile ? "flex-start" : "center"} justifyContent={"space-between"}>
                        {/* <Stack width={"100%"} justifyContent={"flex-end"}>
                            <Stack flexDirection={"row"} justifyContent={mobile ? "space-between" : "flex-end"} width={mobile ? "100%" : "auto"}>
                                <Button onClick={() => navigate("/solicitacao")} color="primary" sx={{ marginRight: "20px", width: "170px" }}>NOVA REQUISIÇÃO</Button>

                            </Stack>
                        </Stack> */}
                        <Stack width={mobile ? "100%" : "unset"} flexDirection={mobile ? "column" : "row"} flexWrap={"wrap"}>
                            {/* <Stack mb={mobile ? "40px" : "0px"} mr={"30px"}>
                                <Typography level="body-sm">N° da Solicitação</Typography>
                                <Stack>
                                    <Input value={solicitacaoBusca} onChange={e => setSolicitacaoBusca(e.target.value)} sx={{ width: "120px" }} />
                                </Stack>
                            </Stack> */}
                            <Stack>
                                <Typography level="body-sm">Criadas a partir de:</Typography>
                                <Input type="date" value={filtros.dataInicio} onChange={(event) => aplicarFiltros('dataInicio', event.target.value)} />
                            </Stack>
                            <Stack ml={mobile ? "0px" : "10px"} mt={mobile ? "10px" : "0px"}>
                                <Typography level="body-sm">Até esta data:</Typography>
                                <Input type="date" value={filtros.dataTermino} onChange={(event) => aplicarFiltros('dataTermino', event.target.value)} />
                            </Stack>
                            <Stack ml={mobile ? "0px" : "10px"} mt={mobile ? "10px" : "0px"} mb={mobile ? "20px" : "0px"}>
                                <Typography level="body-sm">Status</Typography>
                                <Select fontSize={12} value={filtros.status} onChange={(event, newValue) => aplicarFiltros('status', newValue)} placeholder="Status da Solicitação">
                                    <Option value={1}>Em Andamento</Option>
                                    <Option value={2}>Cancelado</Option>
                                    <Option value={3}>Concluído</Option>
                                </Select>
                            </Stack>
                            <Stack ml={mobile ? "0px" : "10px"} mt={mobile ? "10px" : "0px"} mb={mobile ? "20px" : "0px"} width="120px">
                                <Typography level="body-sm">N° Solicitação:</Typography>
                                {/* <input ref={nSolicitacaoRef} type="text" value={filtros.processoPesquisado} placeholder="0000" onChange={(event) => [aplicarFiltros('processoPesquisado', event.target.value), (event.target.value.length > 0 ? aplicarFiltros('verTodasTarefas', true) : null)]} style={{ fontSize: "16px", fontWeight: 500, color: "#333", border: '1px solid #ddd', borderRadius: "5px", padding: "10px 10px", backgroundColor: "#fcfcfc" }} /> */}
                                <input
                                    ref={nSolicitacaoRef}
                                    type="text"
                                    value={filtros.processoPesquisado ?? ''}
                                    onChange={(event) => {
                                        const valor = event.target.value;
                                        aplicarFiltros('processoPesquisado', valor);
                                        if (valor.length > 0) aplicarFiltros('verTodasTarefas', true);
                                    }}
                                    placeholder="0000"
                                    style={{ fontSize: "16px", fontWeight: 500, color: "#333", border: '1px solid #ddd', borderRadius: "5px", padding: "10px 10px", backgroundColor: "#fcfcfc" }}
                                />
                            </Stack>
                            <Stack ml={mobile ? "0px" : "20px"} mb={mobile ? "30px" : "0px"}>
                                <Typography level="body-sm">Ver todos</Typography>
                                <Stack alignSelf={"flex-start"} justifyContent="center" flex={mobile ? null : 1}>
                                    <Switch
                                        checked={Boolean(filtros.verTodasTarefas)}
                                        onChange={(event) => {
                                            const checked = event.target.checked;
                                            aplicarFiltros('verTodasTarefas', checked);
                                            if (!checked) aplicarFiltros('semCotacao', '');
                                        }}
                                    />
                                </Stack>
                            </Stack>

                            <Stack ml={mobile ? "0px" : "20px"} mr={mobile ? "0px" : "20px"} mb={mobile ? "30px" : "0px"}>
                                <Typography level="body-sm">Sem cotação</Typography>
                                <Stack alignSelf={"flex-start"} justifyContent="center" flex={mobile ? null : 1}>
                                    <Switch
                                        checked={filtros.semCotacao}
                                        onChange={(event) => [aplicarFiltros('semCotacao', event.target.checked), event.target.checked ? aplicarFiltros('verTodasTarefas', event.target.checked) : null]}
                                    // onChange={(event) => setVerTodasTarefas(event.target.checked)}
                                    />
                                </Stack>
                            </Stack>

                            <Stack mr={mobile ? "" : "10px"} mb={mobile ? "10px" : "0px"} mt={'10px'} display={"flex"}>
                                <Button color="neutral" variant="solid" onClick={() => setModalFiltros(true)}><FaFilter style={{ marginRight: "5px" }} /> FILTROS</Button>
                                <Link onClick={resetFilters} color="danger" level="body-sm" >Limpar Filtros</Link>
                            </Stack>
                            <Stack ml={mobile ? "" : "0px"} mb={mobile ? "10px" : "0px"} mt={'10px'} display={"flex"}>
                                <Button loading={loading} onClick={() => buscarTarefas()} color="primary">ATUALIZAR</Button>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack flexDirection={"row"} justifyContent={mobile ? "space-between" : "flex-start"} width={mobile ? "100%" : "auto"} mt={'5px'}>
                        <Button onClick={() => navigate("/solicitacao")} color="success" sx={{ marginRight: "20px", width: "170px" }}>NOVA REQUISIÇÃO</Button>
                    </Stack>
                </Stack>
                <Stack mt="30px">

                    <Stack mt={3} alignItems={mobile ? "center" : "flex-end"}>
                        <Paginacao paginaAtual={paginas.paginaAtual} alterarPagina={alterarPagina} totalPaginas={paginas.numeroPaginas} />
                    </Stack>

                    {mobile ?
                        <Stack>
                            {tarefas.map(function (item, indice) {
                                const etapaAtualDoProcesso = item.etapaAtual != "Aprov. Tecnico" ? item.etapaAtual : "Aprov. Técnico";
                                let corDaLinha = "";

                                if (dadosUsuarioLogado.permissoes) {

                                    const obraEPermissao = dadosUsuarioLogado.grupo.filter(grupo => grupo.perfil == etapaAtualDoProcesso
                                        && grupo.obra == item.obra
                                        && grupo.tipoPedido.includes(item.tipoPedido)
                                    ).length > 0;
                                    if (
                                        ((dadosUsuarioLogado.permissoes.indexOf(etapaAtualDoProcesso) != -1) && (etapaAtualDoProcesso != "Solicitante") && (etapaAtualDoProcesso != "Compras") && obraEPermissao) ||
                                        (item.solicitante == dadosUsuarioLogado.nome && item.etapaAtual == "Solicitante") ||
                                        (item.etapaAtual == "Compras" && item.compradorID == dadosUsuarioLogado.id)
                                    ) {
                                        if (item.multiplosAprovadores > 1) {
                                            corDaLinha = "#57cc99";
                                        } else {
                                            corDaLinha = "#ffe082";
                                        }

                                    }
                                }

                                if ((item.decisao == "Reprovado") && (item.solicitante == dadosUsuarioLogado.nome && item.etapaAtual == "Solicitante")) {
                                    corDaLinha = "#ef9a9a";
                                }

                                return (
                                    <div className="hover" key={indice}>
                                        <Stack onClick={() => checarSolicitacaoEmProcessamento(item.solicitacao)} p={"10px"} boxShadow="md" borderRadius={5} mb={"20px"} sx={{ userSelect: "none" }} style={{ backgroundColor: corDaLinha }}>
                                            <Typography level="body-lg" borderBottom={1} borderColor="#ccc" mb={"10px"}><Typography level="title-lg">Solicitação: </Typography>{item.solicitacao}</Typography>
                                            <Typography level="body-sm" sx={{ color: "#222" }}><Typography level="title-md" sx={{ color: "#444" }}>Solicitante: </Typography>{item.solicitante}</Typography>
                                            <Typography level="body-sm" sx={{ color: "#222" }}><Typography level="title-md" sx={{ color: "#444" }}>Etapa Atual: </Typography>{item.etapaAtual}</Typography>
                                            <Typography level="body-sm" sx={{ color: "#222" }}><Typography level="title-md" sx={{ color: "#444" }}>Comprador: </Typography>{item.comprador}</Typography>
                                            <Typography level="body-sm" sx={{ color: "#222" }}><Typography level="title-md" sx={{ color: "#444" }}>N° Movimento.: </Typography>{item.numeroPms}</Typography>
                                            <Typography level="body-sm" sx={{ color: "#222" }}><Typography level="title-md" sx={{ color: "#444" }}>Data Abertura: </Typography>{item.dataAbertura}</Typography>
                                            <Typography level="body-sm" sx={{ color: "#222" }}><Typography level="title-md" sx={{ color: "#444" }}>Ultima Movimetação: </Typography>{item.ultimaMovimentacao}</Typography>
                                            <Typography level="body-sm" sx={{ color: "#222" }}><Typography level="title-md" sx={{ color: "#444" }}>Status: </Typography>{statusSolicitacao(item.status)}</Typography>
                                            <h4 onClick={(e) => exibirItens(e, item.solicitacao)} style={{ padding: 0, margin: 0, marginTop: "10px", color: "#1565c0" }}>Ver Itens</h4>
                                        </Stack>
                                    </div>
                                )
                            })}
                        </Stack>
                        :
                        <Stack>
                            <Table hoverRow noWrap>
                                <thead>
                                    <tr>
                                        <th style={{ height: "25px", width: "75px" }}><Link onClick={() => handleOrdenaSolicitacao()}>Solicitação {ordenaSolicitacao != null ? ordenaSolicitacao ? <FaArrowDown size={10} style={{ marginLeft: "2px" }} /> : <FaArrowUp size={10} style={{ marginLeft: "2px" }} /> : ""} </Link></th>
                                        <th style={{ height: "25px", width: "100px" }}></th>
                                        <th style={{ height: "25px", width: "88px", textAlign: "center" }}>Prioridade</th>
                                        <th style={{ height: "25px", width: "40px" }}>Filial</th>
                                        <th style={{ height: "25px", width: "70px" }}>Estoque</th>
                                        <th style={{ height: "25px", width: "100px" }}>Nº Movimento</th>
                                        <th style={{ height: "25px", width: "150px", flexGrow: 2 }}><Link onClick={() => handleOrdenaSolicitante()}>Nome do Solicitante {ordenaSolicitante != null ? ordenaSolicitante ? <FaArrowDown size={10} style={{ marginLeft: "2px" }} /> : <FaArrowUp size={10} style={{ marginLeft: "2px" }} /> : ""} </Link></th>
                                        <th style={{ height: "25px", width: "100px", flexGrow: 1 }}><Link onClick={() => handleOrdenaEtapaAtual()}>Etapa Atual {ordenaEtapaAtual != null ? ordenaEtapaAtual ? <FaArrowDown size={10} style={{ marginLeft: "2px" }} /> : <FaArrowUp size={10} style={{ marginLeft: "2px" }} /> : ""} </Link></th>
                                        <th style={{ height: "25px", minWidth: "300px", flexGrow: 3 }}><Link onClick={() => handleOrdenaComprador()}>Comprador {ordenaComprador != null ? ordenaComprador ? <FaArrowDown size={10} style={{ marginLeft: "2px" }} /> : <FaArrowUp size={10} style={{ marginLeft: "2px" }} /> : ""} </Link></th>
                                        <th style={{ height: "25px", width: "100px", flexGrow: 3 }}>Aprov. Atual</th>
                                        <th style={{ height: "25px", width: "65px", flexGrow: 3 }}>Revisado</th>
                                        <th style={{ height: "25px", minWidth: "90px" }}><Link onClick={() => handleOrdenaDataAbertura()}>Data Abertura {ordenaDataAbertura != null ? ordenaDataAbertura ? <FaArrowDown size={10} style={{ marginLeft: "2px" }} /> : <FaArrowUp size={10} style={{ marginLeft: "2px" }} /> : ""} </Link></th>
                                        <th style={{ height: "25px", width: "100px" }}><Link onClick={() => handleOrdenaUltimaMovimentacao()}>Ultima Mov. {ordenaUltimaMovimentacao != null ? ordenaUltimaMovimentacao ? <FaArrowDown size={10} style={{ marginLeft: "2px" }} /> : <FaArrowUp size={10} style={{ marginLeft: "2px" }} /> : ""} </Link></th>
                                        <th style={{ height: "25px", width: "120px" }}>Status</th>
                                        {/* <th style={{ height: "25px", width: "100px" }}></th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tarefas.map(function (item, indice) {

                                        const etapaAtualDoProcesso = item.etapaAtual != "Aprov. Tecnico" ? item.etapaAtual : "Aprov. Técnico";
                                        let corDaLinha = "";

                                        // console.log(item);

                                        if (dadosUsuarioLogado.permissoes) {

                                            const obraEPermissao = dadosUsuarioLogado.grupo.filter(grupo => grupo.perfil == etapaAtualDoProcesso
                                                && grupo.obra == item.obra
                                                && grupo.tipoPedido.includes(item.tipoPedido)
                                            ).length > 0;
                                            if (
                                                ((dadosUsuarioLogado.permissoes.indexOf(etapaAtualDoProcesso) != -1) && (etapaAtualDoProcesso != "Solicitante") && (etapaAtualDoProcesso != "Compras") && obraEPermissao) ||
                                                (item.solicitante == dadosUsuarioLogado.nome && item.etapaAtual == "Solicitante") ||
                                                (item.etapaAtual == "Compras" && item.compradorID == dadosUsuarioLogado.id)
                                            ) {
                                                if (item.multiplosAprovadores > 1) {
                                                    corDaLinha = "#57cc99";
                                                } else {
                                                    corDaLinha = "#ffe082";
                                                }

                                            }
                                        }

                                        if ((item.decisao == "Reprovado") && (item.solicitante == dadosUsuarioLogado.nome && item.etapaAtual == "Solicitante")) {
                                            corDaLinha = "#ef9a9a";
                                        }

                                        return (
                                            <tr key={indice} className="hover" onClick={() => checarSolicitacaoEmProcessamento(item.solicitacao)} style={{ backgroundColor: corDaLinha }} >
                                                <td style={{ padding: "0 10px" }}>{item.solicitacao}</td>
                                                <td style={{ padding: "0 10px", fontWeight: "bold", display: "flex", flexDirection: "row", alignItems: "center", gap: "20px" }}>
                                                    <h4 onClick={(e) => exibirItens(e, item.solicitacao)} style={{ padding: 0, margin: 0, color: "#1565c0" }}>Ver Itens</h4>
                                                    <FaExternalLinkAlt onClick={(e) => checarSolicitacaoEmProcessamento(item.solicitacao, true, e)} />
                                                </td>
                                                <td style={item.criterio == "Urgente" ? { padding: "0 10px", color: "#f44336", textAlign: "center", fontWeight: "bold" } : { padding: "0 10px", textAlign: "center" }}>{item.criterio}</td>
                                                <td style={{ padding: "0 10px" }}>{item.filial}</td>
                                                <td style={{ padding: "0 10px" }}>{item.localEstoque}</td>
                                                <Tooltip arrow title={"Copiar"} color="primary" placement="left" variant={"solid"}>
                                                    <td style={{ padding: "0 10px" }}><FaCopy onClick={(e) => copiarNumMovimento(e, item.numeroPms)} style={{ marginRight: "8px", cursor: "pointer", color: "#1976d2" }} /><label style={{ cursor: "pointer" }}>{item.numeroPms}</label></td>
                                                </Tooltip>
                                                <Tooltip arrow title={item.solicitante} color="primary" placement="bottom" variant={"solid"}>
                                                    <td style={{ padding: "0 10px" }}>{item.solicitante}</td>
                                                </Tooltip>
                                                <Tooltip arrow title={item.etapaAtual} color="primary" placement="bottom" variant={"solid"}>
                                                    <td style={{ padding: "0 10px" }}>{item.etapaAtual}</td>
                                                </Tooltip>
                                                <Tooltip arrow title={item.comprador} color="primary" placement="bottom" variant={"solid"}>
                                                    <td style={{ padding: "0 10px" }}>{item.comprador}</td>
                                                </Tooltip>
                                                <Tooltip arrow title={item.aprovadorAtual} color="primary" placement="bottom" variant={"solid"}>
                                                    <td style={{ padding: "0 10px" }}>{item.aprovadorAtual}</td>
                                                </Tooltip>
                                                <Tooltip arrow title={item.jaReprovado ? "Processo reprovado anteriormente, favor verificar se todos os questionamentos foram atendidos." : ""} color="warning" placement="bottom" variant={"solid"}>
                                                    <td style={item.jaReprovado ? { padding: "0 10px", color: "#f57c00", fontWeight: "bold" } : { padding: "0 10px" }}>{item.jaReprovado ? "Sim" : "Não"}</td>
                                                </Tooltip>
                                                <td style={{ padding: "0 10px" }}>{item.dataAbertura}</td>
                                                <td style={{ padding: "0 10px" }}>{item.ultimaMovimentacao}</td>
                                                <td style={{ padding: "0 10px", fontWeight: "bold" }}>{statusSolicitacao(item.status)}</td>
                                                {/* <td style={{ padding: "0 10px", fontWeight: "bold", display: "flex", flexDirection: "row", alignItems: "center", gap: "20px" }}>
                                                    <h4 onClick={(e) => exibirItens(e, item.solicitacao)} style={{ padding: 0, margin: 0, color: "#1565c0" }}>Ver Itens</h4>
                                                    <FaExternalLinkAlt onClick={(e) => checarSolicitacaoEmProcessamento(item.solicitacao, true, e)} />
                                                </td> */}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Stack>
                    }
                    <Stack mt={3} alignItems={mobile ? "center" : "flex-end"}>
                        {/* <Pagination
                            onChange={alterarPagina}
                            count={paginas.numeroPaginas}
                            page={paginas.paginaAtual}
                            hideNextButton={paginas.paginaAtual == paginas.numeroPaginas}
                            hidePrevButton={paginas.paginaAtual == 1}
                        /> */}
                        <Paginacao paginaAtual={paginas.paginaAtual} alterarPagina={alterarPagina} totalPaginas={paginas.numeroPaginas} />
                    </Stack>
                </Stack>
            </Stack>

            <Modal open={modalExibirItens} onClose={() => setModalExibirItens(false)}>
                <ModalDialog>
                    <ModalClose />
                    <Typography sx={{ fontWeight: "bold" }}>Itens da Requisição</Typography>
                    <Typography sx={{ color: "#444", fontSize: 14, marginTop: '3px' }}>Tipo de Pedido: <Typography sx={{ backgroundColor: "#eee", padding: '2px 5px', borderRadius: '5px' }}>{itensDaRequisicao[0]?.tipoPedido}</Typography></Typography>
                    <Stack overflow={"auto"} sx={{ marginTop: '5px' }}>
                        <Table hoverRow noWrap>
                            <thead>
                                <tr>
                                    <th style={{ height: "25px", width: "30px" }}>Item</th>
                                    <th style={{ height: "25px", width: "50px" }}>Código</th>
                                    <th style={{ height: "25px", minWidth: "100px" }}>Descrição</th>
                                    <th style={{ height: "25px", width: "50px" }}>Saldo</th>
                                    <th style={{ height: "25px", width: "50px" }}>Qtd.</th>
                                    <th style={{ height: "25px", width: "100px" }}>Qtd. Comprar</th>
                                    {/* <th style={{ height: "25px", width: "300px" }}>Tipo Pedido</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {itensDaRequisicao.map(function (item, indice) {
                                    console.log(item);
                                    return (
                                        <tr key={indice}>
                                            <td style={{ padding: "0 10px" }}>{indice + 1}</td>
                                            <td style={{ padding: "0 10px" }}>{item.codProduto}</td>
                                            <td style={{ padding: "0 10px" }}>{item.descricao}</td>
                                            <td style={{ padding: "0 10px" }}>{item.estoque}</td>
                                            <td style={{ padding: "0 10px" }}>{item.quantidadeProduto}</td>
                                            <td style={{ padding: "0 10px" }}>{item.quantidadeComprarRM}</td>
                                            {/* <td style={{ padding: "0 10px" }}>{item.tipoPedido}</td> */}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </Stack>
                </ModalDialog>
            </Modal>

            <Modal open={modalFiltros} onClose={() => setModalFiltros(false)}>
                <ModalDialog>
                    <ModalClose />
                    <Typography fontSize={"18px"} mb={"16px"} fontWeight={"bold"}>Filtros</Typography>
                    {/* <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            // buscarTarefas();
                            setModalFiltros(false)
                        }}
                    > */}
                    <button type="submit" style={{ display: 'none' }} />
                    <Stack sx={mobile ? { width: "100%", maxHeight: "70vh" } : { width: "400px", maxHeight: "70vh" }} gap={"14px"} overflow={"auto"}>
                        <Stack mb={mobile ? "20px" : "0px"}>
                            <Typography level="body-sm" fontWeight={"bold"}>Etapa Atual</Typography>
                            <Select fontSize={12} value={filtros.etapaAtualBuscada} onChange={(event, newValue) => aplicarFiltros('etapaAtualBuscada', newValue)} placeholder="Selecionar">
                                <Option value={null} selected>Todas</Option>
                                <Option value={"Solicitante"}>Solicitante</Option>
                                <Option value={"Aprov. Técnico"}>Aprov. Técnico</Option>
                                <Option value={"Aprov. Gerencial"}>Aprov. Gerencial</Option>
                                <Option value={"Aprov. Institucional"}>Aprov. Institucional</Option>
                                <Option value={"Análise Crítica Compras"}>Análise Crítica Compras</Option>
                                <Option value={"Compras"}>Compras</Option>
                                <Option value={"Faturado"}>Faturado</Option>
                            </Select>
                        </Stack>
                        <Stack mt={mobile ? "10px" : "0px"} mb={mobile ? "20px" : "0px"}>
                            <Typography fontSize="14px" fontWeight={"bold"}>Solicitante</Typography>
                            <Autocomplete
                                value={filtros.solicitante}
                                onChange={(event, newValue) => aplicarFiltros('solicitante', newValue)}
                                placeholder="Nome do Solicitante"
                                options={listagemUsuarios}
                                getOptionLabel={option => option.nome}
                            />
                        </Stack>
                        <Stack mt={mobile ? "10px" : "0px"} mb={mobile ? "20px" : "0px"}>
                            <Typography level="body-sm" fontWeight={"bold"}>N° Movimento:</Typography>
                            <Input type="text" placeholder="000000" value={filtros.numMovPesquisado} onChange={(event) => aplicarFiltros('numMovPesquisado', event.target.value)} />
                        </Stack>
                        <Stack mt={mobile ? "10px" : "0px"} mb={mobile ? "20px" : "0px"}>
                            <Typography level="body-sm" fontWeight={"bold"}>Filtrar por local de estoque:</Typography>
                            <Input type="text" value={filtros.obraPesquisada} placeholder="000.00" onChange={(event) => aplicarFiltros('obraPesquisada', event.target.value)} />
                        </Stack>
                        <Stack mt={mobile ? "10px" : "0px"} mb={mobile ? "20px" : "0px"}>
                            <Typography level="body-sm" fontWeight={"bold"}>N° Solicitação</Typography>
                            <input
                                ref={nSolicitacaoRef}
                                type="text"
                                value={filtros.processoPesquisado}
                                placeholder="0000"
                                // onChange={(event) => aplicarFiltros('processoPesquisado', event.target.value)}
                                onChange={(event) => {
                                    const valor = event.target.value;
                                    aplicarFiltros('processoPesquisado', valor);
                                    if (valor.length > 0) aplicarFiltros('verTodasTarefas', true);
                                }}
                                style={{ fontSize: "16px", fontWeight: 500, color: "#333", border: '1px solid #ddd', borderRadius: "5px", padding: "10px 10px", backgroundColor: "#fcfcfc" }}
                            />
                        </Stack>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>Procurar por item (Mínimo 5 caracteres)</Typography>
                            <Stack>
                                <Input value={filtros.item} onChange={e => aplicarFiltros("item", e.target.value)} onBlur={() => (filtros.item && filtros.item.length > 0 && filtros.item.length < 5) ? [aplicarFiltros("item", ""), toast.warning("A descrição do item precisa conter pelo menos 5 caracteres.")] : null} placeholder="Descrição do item" />
                            </Stack>
                        </Stack>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>Prefixo do equipamento</Typography>
                            <Stack>
                                <Input value={filtros.prefixoEquipamento} onChange={e => aplicarFiltros("prefixoEquipamento", e.target.value.replace(/[^0-9.]/g, ''))} placeholder="0.000.0000" />
                            </Stack>
                        </Stack>
                    </Stack>
                    {/* </form> */}
                    <Stack flexDirection={"row"} mt="26px" justifyContent={"space-between"}>
                        <Button onClick={() => setModalFiltros(false)} color="neutral">FECHAR</Button>
                        <Button loading={loading} onClick={() => [buscarTarefas(), setModalFiltros(false)]}><FaSearch style={{ marginRight: "5px" }} /> ATUALIZAR</Button>
                    </Stack>
                </ModalDialog>
            </Modal>

        </Stack >
    );
}